export default __webpack_public_path__ + "media/fonts/icomoon/fonts/icomoon-ae01aebe5bc5bc8aa2bca1a12a560450.svg";